import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
// import Style from "../assets/css/main.module.css";
import amusementparks from "../assets/images/amusement-park.png";
import coupon from "../assets/icons/coupon-2-line.png";
import clock from "../assets/icons/clock.svg";
import locationIcon from "../assets/icons/location.svg";

export default function ParkCard({ park }) {
  const navigate = useNavigate();
  return (
    <div className="bg-light">
      <div className="row g-0 border border-2 bg-white mb-4 rounded-3 shadow-sm flex-column flex-md-row">
        {/* Image Column */}
        <div className="col-12 col-md-3 text-center d-flex justify-content-center align-items-center p-3">
          <button
            type="button"
            className="bg-transparent border-0 p-0 m-0"
            style={{ boxShadow: "none" }}
            onClick={() => navigate(`/park-details/${park?.id}`)}
            aria-label={`View details for ${park?.name}`}
          >
            <img
              width="100%"
              height="auto"
              style={{ maxHeight: "200px", objectFit: "cover" }}
              loading="lazy"
              data-testid="park-logo"
              srcSet={`${park?.logo || amusementparks} 1x, ${park?.logo || amusementparks} 2x`}
              className="img-fluid rounded"
              src={park?.logo || amusementparks}
              alt="amusement-parks"
            />
          </button>
        </div>

        {/* Middle Content */}
        <div className="col-12 col-md-6 px-3 py-3">
          <h5 className="fw-semibold fs-4 lh-base mb-2 font-libre">
            {park?.name}
          </h5>

          {/* Mobile View */}
          <button
            type="button"
            className="d-md-none mb-3 w-100 text-start bg-transparent border-0 p-0"
            onClick={() => navigate(`/park-details/${park?.id}`)}
            style={{ boxShadow: "none" }}
          >
            <div className="d-flex align-items-center mb-2">
              <img src={clock} alt="clock" />
              <span className="ms-2">{park?.start_time}</span>
            </div>
            <div className="d-flex align-items-center mb-2">
              <img src={locationIcon} alt="location" />
              <span className="ms-2">
                {park?.branches?.[0]?.name || "No location"}
              </span>
            </div>
            <div>
              <div>From</div>
              <div className="fw-medium fs-5 text-success font-metropolis">
                ৳ {park?.min_price} - {park?.max_price}
              </div>
            </div>
          </button>

          {/* Desktop Rides */}
          <div className="d-none d-md-block">
            <div className="text-muted small fw-normal mb-1 font-inter">
              Rides:
            </div>
            <div className="d-flex flex-wrap mb-3">
              {park?.rides?.length > 0 &&
                park?.rides?.map(
                  (ride, index) =>
                    index < 2 && (
                      <span
                        key={ride?.id}
                        className="badge rounded-pill text-success bg-success bg-opacity-10 me-2 mb-2 px-3 py-2 fw-bold font-inter"
                        style={{ fontSize: "12px" }}
                      >
                        {ride?.name}
                      </span>
                    )
                )}
              {park?.rides?.length > 2 && (
                <Dropdown className="park-item-list-dropdown">
                  <Dropdown.Toggle
                    as="span"
                    className="text-success small font-libre"
                    style={{ cursor: "pointer" }}
                  >
                    + {(park?.rides?.length || 0) - 2} More Rides
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {park?.rides.map((ride, index) => index > 1 && (
                      <Dropdown.ItemText key={ride.id}>{ride.name}</Dropdown.ItemText>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>

            <div className="text-muted small fw-normal mb-1 font-inter">
              Locations:
            </div>
            <div className="d-flex flex-wrap">
              {park?.branches?.map(
                (loc, index) =>
                  index < 2 && (
                    <span
                      key={loc?.id}
                      className="badge rounded-pill text-success bg-success bg-opacity-10 me-2 mb-2 px-3 py-2 fw-bold font-inter"
                      style={{ fontSize: "12px" }}
                    >
                      {loc?.name}
                    </span>
                  )
              )}
              {park?.branches?.length > 2 && (
                <Dropdown className="park-item-list-dropdown">
                  <Dropdown.Toggle
                    as="span"
                    className="text-success small font-libre"
                    style={{ cursor: "pointer" }}
                  >
                    + {(park?.branches?.length || 0) - 2} More Locations
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {park?.branches.map((branch, index) => index > 1 && (
                      <Dropdown.ItemText key={branch.id}>{branch.name}</Dropdown.ItemText>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          </div>
        </div>

        {/* Right Side (Desktop only) */}
        <div className="col-md-3 d-none d-md-flex flex-column justify-content-between border-start border-2 px-3 py-3">
          <div className="d-flex align-items-center justify-content-center mb-3">
            <img
              src={coupon}
              alt="coupon icon"
              width="25"
              height="25"
              className="me-2"
            />
            <span className="fw-semibold fs-5 text-muted font-libre">
              ৳ {park?.min_price} - {park?.max_price}
            </span>
          </div>
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-success fw-bold px-4 py-2 font-inter"
              onClick={() => navigate(`/park-details/${park?.id}`)}
            >
              View Park
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
